/*
Descrição..........: Arquivo ts, que contém as funções necessárias
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 20/03/2020


Funções/Métodos:
-----
async loadProd() retorno: lista de registros
Função que chama o service para trazer todos os registros da tebela em questão
-----
searchButtonClick(), doSearchBarCancel() retorno: nenhum
Funções referentes a exibição ou não da barra de pesquisa na view
-----
async doSearchBarChange($event: any) retorno: lista de registros
Chama no service o filtro, e a barra ao receber qualquer dado retorna os registros que contém o que foi digitado
-----
private async executeDelete(category: Categoria) retorno: chamada de função
Abre a caixa de confirmação antes da exclusão e chama a função de delete se a resposta for positiva
-----
 delete(category: Categoria) retorno: nenhum
 Chama o metodo deletar do service e deleta o registro selecionado
-----
*/



import { Component, OnInit } from '@angular/core';
import { Produto } from 'src/app/model/produto';
import { ToastService } from 'src/app/core/toast.service';
import { AlertService } from 'src/app/core/alert.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { GlobalService } from 'src/app/dao/global.service';
import { SelectItem } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-produto-list',
  templateUrl: './produto-list.page.html',
  styleUrls: ['./produto-list.page.scss'],
})
export class ProdutoListPage implements OnInit {
// tslint:disable-next-line: no-inferrable-types
showSearch: boolean = false;
produtos: Produto[] = [];
prod: Produto;
inicio = '';
fim = '';
user: string;
pass: string;
idCategoria;


constructor(private route: ActivatedRoute,
            private toast: ToastService,
            private alert: AlertService,
            private apiproduto: ProdutoapiService,
            private global: GlobalService) { }



ngOnInit() {
 this.user = this.global.user;
 this.pass = this.global.pass;

 const idParam = this.route.snapshot.paramMap.get('id');
 if (idParam) {
   // tslint:disable-next-line: radix
   this.idCategoria = parseInt(idParam);
   // tslint:disable-next-line: radix
   this.loadProd(parseInt(idParam));
 }
}

ionViewWillEnter() {
  this.user = this.global.user;
  this.pass = this.global.pass;
}

async loadProd(idCat) {
  this.apiproduto.GetByCat(idCat).then(res => {
    this.produtos = res;
    //this.toast.showSucess('Produtos obtidos com sucesso!');
  }).catch(async err => {
    console.log('err', err);
    this.toast.showError('Erro ao obter Produtos');
  });
}
searchButtonClick() {
  this.showSearch = true;
}

doSearchBarCancel() {
  this.showSearch = false;
  this.loadProd(this.idCategoria);
}

async doSearchBarChange($event: any) {
  let value = $event.target.value;
  // if (value && value.lenght >= 2) {
  value = value.replace(/\s+/g, "_");
  this.produtos = await this.apiproduto.GetByNomeCat(value, this.idCategoria);
  // }
}



delete(produto: Produto) {
  this.alert.showConfirmDelete(produto.nome, () => this.executeDelete(produto));
}

private async executeDelete(produto: Produto) {
  try {
    await this.apiproduto.excluir(produto.id);
    const index = this.produtos.indexOf(produto);
    this.produtos.splice(index, 1);
    this.toast.showSucess('Produto excluído com sucesso!');
  } catch (error) {
    this.toast.showError('Ocorreu um erro ao tentar excluir o Produto!');
  }

}

mudastts(prod: Produto) {
const novoStatus = !prod.ativo;
prod.ativo = novoStatus;
this.apiproduto.atualizar(prod)
   .then(() => {
     const acao = novoStatus ? 'ativado' : 'desativado';
     prod.ativo = novoStatus;
     this.toast.showSucess(`Produto ${acao} com sucesso!`);
   })
   .catch(erro => {
     console.log(erro);
     this.toast.showError('Erro ao Alterar Status');
   });

}

}

